/* eslint-disable arrow-body-style */
import { create } from 'zustand';
import { GraphHoverStore } from '../types';

export const useCyNodeHoverStore = create<GraphHoverStore>(() => {
  return {
    nodeLabel: '',
    nodeValue: '',
    style: {},
    clazz: '',
    copied: false,
  };
});

export async function copyNodeValue() {
  const wait = async () => new Promise((resolve) => setTimeout(resolve, 900));

  const store = useCyNodeHoverStore.getState();
  await navigator.clipboard.writeText(store.nodeValue);
  useCyNodeHoverStore.setState({ copied: true });
  await wait();
  useCyNodeHoverStore.setState({ copied: false });
}
